<template>
  <div>
    <!--退票弹窗-->
    <a-modal
      title="请确认您的信息"
      v-model="refundModVisible"
      wrapClassName="order-modal refund-modal"
      :okText="'确认'"
      :cancelText="'取消'"
      :closable="false"
      :width="640"
      :destroyOnClose="true"
      @ok="refundInfoOk"
    >
      <div class="refund-mod-notice">确定要提交退票申请吗？您的座位将被释放，此操作不能回退！</div>
      <template v-for="(seg, segIndex) in refundSegs">
        <div :key="segIndex">
          <div class="refund-mod-subtitle">{{seg.departureName}} - {{seg.arrivalName}} {{seg.cabinCode}}舱： 客票退改规则</div>
          <RemarkTable
            :rule="seg.remark"
            :isJJC="seg.productCode?.indexOf('JJC') >= 0"
          ></RemarkTable>
        </div>
      </template>
      <div class="refund-mod-p">
        <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 以上退改签费用标准仅供参考，请以实际情况为准。<br/>
        <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 客票变更时，需同时收取票价价差和变更手续费。
      </div>
      <!-- <div class="refund-mod-tip">
        <div class="_tip _tip-icon">
          <l8-icon class="l8-icon" type="icon-xunhuan1"/>
        </div>
      </div> -->
    </a-modal>
    <!--退票确认弹窗-->
    <a-modal
      title="提交退票申请"
      v-model="refundApplyModVisible"
      wrapClassName="order-modal apply-modal"
      :okText="'提交'"
      :cancelText="'取消'"
      :closable="false"
      :width="640"
      :confirmLoading="refundApplyLoading"
      @ok="refundApplyOk"
    >
      <div class="apply-mod-title">退票类型</div>
      <a-select
        class="apply-select"
        dropdownClassName="apply-dropdown"
        defaultValue="UNCONSTRAINT"
        style="width: 100%"
        @change="refundTypeChangeHandler">
        <a-select-option value="UNCONSTRAINT">自愿</a-select-option>
        <a-select-option value="CONSTRAINT">非自愿</a-select-option>
      </a-select>
      <div class="apply-reason">
        <template v-if="refundType !== 'UNCONSTRAINT'">
          <div class="apply-mod-title">退票原因</div>
          <div class="apply-radio-group">
            <a-radio-group name="applyGroup" defaultValue="UNTK" v-model="refundReasonType">
              <a-radio value="CHANGE">升舱改期/客票换开</a-radio>
              <a-radio value="UNTK">航班取消/延误</a-radio>
              <a-radio value="BINGTUI">病退</a-radio>
              <a-radio value="REPEAT">重复购票</a-radio>
              <a-radio value="OTHER">其他</a-radio>
            </a-radio-group>
          </div>
          <div v-if="refundReasonType === 'CHANGE'">请备注新出客票号，待新客票使用后原客票进行退款。</div>
          <div v-if="refundReasonType === 'UNTK'">航班变动信息属实则予以全退，不符合不正常航班定义的将按自愿退票进行处理。</div>
          <div v-if="refundReasonType === 'BINGTUI'">选择病退原因时，需提供病退材料。</div>
          <div v-if="refundReasonType === 'REPEAT'">请备注重复购票票号:<br>①重复购票退座时间必须在航班计划起飞前24小时（含）前;<br>②旅客重复购买的两张客票的购票时间间隔需在24小时以内(含);<br>③在出票后24小时(含)内提出重复购票退票申请并取消航班座位，则一张客票可免手续费，其他将按自愿退票处理；票价不一致时仅免费退最后一次购买的客票。</div>
        </template>
        <template v-if="refundType === 'UNCONSTRAINT'">
          <div>尊敬的用户，您提交的自愿退票将按照航司多等级舱位管理规定收取手续费。</div>
          <!-- <div>温馨提示: </div>
          <div>购票日期为2021年1月27日0时前，乘机日期在1月28日-2月3日，航班起飞前退票免收退票手续费；乘机日期在2月4日至3月8日，航班起飞前7天退票免收退票手续费。</div>
          <div>在2020年1月28日（不含）之前购买了2020年1月1日（含）至2020年3月31日（含）间起飞的祥鹏航空（8L）国内航班机票的旅客，如您暂不出行，可在购票1年内免费变更一次至2021年1月31日（含）前的同航段同舱位航班，您可在确定行程后，打开“旅行服务—不正常航班/疫情影响客票改期”输入相应的客票号进行办理。</div> -->
        </template>
      </div>
      <div class="apply-reason-text">
        <a-textarea v-model="refundReason" placeholder="备注" :rows="4"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import storage from '@/assets/js/storage'
import RemarkTable from '@/components/passenger-seg-list/module/remark-table.vue'
import { refundV1 } from '@/apis/order'

const passengerTypeSort = ['ADULT', 'CHILD', 'INFANT']

export default {
  name: 'DetailRefund',
  props: {
    detail: {
      type: Object
    },
    selectedSeg: {
      type: Array
    }
  },
  data () {
    return {
      refundSegs: [],
      refundType: 'UNCONSTRAINT',
      refundReasonType: 'UNTK',
      refundReason: '',
      // 退票弹窗控制
      refundModVisible: false,
      refundApplyModVisible: false,
      refundApplyLoading: false
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  methods: {
    startRefund () {
      if (this.detail.changes.length) { // 有改期时，不提示退改规则
        this.refundApplyModVisible = true
      } else {
        this.refundModVisible = true
      }
      this.fetchRefundModal()
    },
    fetchRefundModal () {
      const refundSegs = _.groupBy(JSON.parse(JSON.stringify(this.selectedSeg)), (seg) => {
        // 基于中转场景，优化分组 key 的选择
        return `${seg.departureCode}-${seg.arrivalCode}`
      })
      const segments = []

      for (const key in refundSegs) {
        segments.push(refundSegs[key].sort(function (a, b) {
          const aIdx = passengerTypeSort.indexOf(a.passenger.type)
          const bIdx = passengerTypeSort.indexOf(b.passenger.type)

          return aIdx - bIdx
        })[0])
      }

      _.each(segments, (seg) => {
        if (seg.refundChangeFee) {
          seg.remark = seg.refundChangeFee
        } else {
          this.refundApplyModVisible = true
          this.refundModVisible = false
        }
      })

      this.refundSegs = segments
    },
    refundInfoOk () {
      this.refundModVisible = false
      this.refundApplyModVisible = true
    },
    refundApplyOk () {
      const { value: userInfo } = storage.getItem('USER_CENTER_INFO') || {}

      if (userInfo && (userInfo.userType === 1 || userInfo.userType === 2)) {
        // 代理人
        this.$info({
          title: '温馨提示',
          content: '尊敬的用户，由于权限问题，部分退票系统无法自动清位，请在提交退票后检查编码状态，若未清位请手工清位，避免出现虚耗情况，谢谢您的配合。',
          okText: '确认',
          onOk: () => {
            this.applyRefund()
          }
        })
      } else {
        this.applyRefund()
      }
    },
    async applyRefund () {
      let refundSegIds = _.map(this.selectedSeg, (seg) => (seg.id))

      // 退票原因传中文
      let refundReasonTypeMap = {
        'CHANGE': '升舱改期/客票换开',
        'UNTK': '航班取消/延误 ',
        'BINGTUI': '病退',
        'REPEAT': '重复购票',
        'OTHER': '其他'
      }

      let params = {
        'constraintReason': this.refundType === 'CONSTRAINT' ? refundReasonTypeMap[this.refundReasonType] : '',
        'orderId': this.detail.orderId,
        'orderItemServiceDetailIds': refundSegIds,
        'refundType': this.refundType,
        'remark': this.refundReason
      }

      this.refundApplyLoading = true

      refundV1(params).then((res) => {
        this.refundApplyLoading = false
        this.refundApplyModVisible = false
        this.$message.success('退票成功，正在刷新页面。')
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      }).catch((error) => {
        this.refundApplyLoading = false
        this.refundApplyModVisible = false
        this.$message.error(error.message || '退票失败，请稍候重试。')
      })
    },
    refundTypeChangeHandler (value) {
      this.refundType = value
    }
  },
  components: {
    RemarkTable
  }
}
</script>

<style lang="less">
/*订单弹窗样式*/
.order-modal {
  /*退票弹窗*/
  &.refund-modal {
    .refund-mod-notice {
      font-size: 12px;
      font-weight: 700;
      color: @primary-color;
      margin: 0 0 20px;
      text-align: center;
    }

    .refund-mod-subtitle {
      font-size: 16px;
      margin: 10px 0;
      text-align: center;
    }

    .refund-mod-p {
      margin: 10px 0;
    }

    .refund-mod-tip {
      display: table;
      ._tip {
        display: table-cell;

        &._tip-icon {
          vertical-align: top;
          padding-right: 10px;
        }
      }
    }
  }

  /*退票类型弹窗*/
  &.apply-modal {
    font-size: 12px;

    .apply-mod-title {
      font-size: 12px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .apply-reason {
      padding: 15px 0;
    }

    .apply-mod-title {
    }

    .apply-radio-group {
      padding: 5px 0 15px;

      .ant-radio-wrapper {
        font-size: 12px;
      }
    }

    .apply-reason-text {
      .ant-input {
        font-size: 12px;
      }
    }

    .ant-select.apply-select {
      font-size: 12px;

      .ant-select-selection {
        &.ant-select-selection--single {
          height: 42px;
        }
      }

      .ant-select-selection__rendered {
        line-height: 40px;
      }
    }

    .apply-refund-files {
      .apply-mod-title {
        margin-top: 10px;
      }
      .upload-tips {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
